import styled, {keyframes} from 'styled-components';

const move = keyframes`
  0% {
    transform: scaleY(1.2);
  }
  50% {
    transform: scaleY(0.5);
  }
  100% {
    transform: scaleY(1.2);
  }
`;

export const Ul = styled.ul`
  display: flex;
  .li {
    list-style: none;
    width: 10px;
    height: 60px;
    background: #838383ff;
    margin: 0 3px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px #838383ff;
    border: 1px solid #3f3f3fff;
  }
  .liButton {
    list-style: none;
    width: 6px;
    height: 25px;
    background: #838383ff;
    margin: 0 3px;
    border-radius: 5px;
  }
  .li-1{
    animation: ${move} 0.70s ease-in-out 0.1s infinite;
  }
  .li-2{
    animation: ${move} 0.70s ease-in-out 0.2s infinite;
  }
  .li-3{
    animation: ${move} 0.70s ease-in-out 0.3s infinite;
  }
  .li-4{
    animation: ${move} 0.70s ease-in-out 0.4s infinite;
  }
  .li-5{
    animation: ${move} 0.70s ease-in-out 0.5s infinite;
  }
  .li-6{
    animation: ${move} 0.70s ease-in-out 0.6s infinite;
  }
  /* @for $i from 1 through 6 {
    .li-#{$i} {
      animation: ${move} 0.70s ease-in-out $i * 0.05s infinite;
    }
  } */

`;
